// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import 'element-ui/lib/theme-chalk/index.css'
import './style/base.css'
import VueResource from 'vue-resource'
import ElementUI from 'element-ui'
import router from './router'
import axios from 'axios'
import common from './common/common'//引用模块进来
import utils from '../src/js/utils'
import Print from 'vue-print-nb'
// import Cookies from 'js-cookie'
Vue.config.productionTip = false;
Vue.prototype.$axios = axios;    //全局注册，使用方法为:this.$axios
// Vue.prototype.$cookies = Cookies 
Vue.prototype.Common = common;
Vue.prototype.$utils = utils
Vue.use(ElementUI)
Vue.use(VueResource)
Vue.use(Print);
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js